// material-ui
import Grid from '@material-ui/core/Grid';

// components
import GrantSystemAdminCard from './GrantSystemAdminCard';
import SystemAdminsTable from './SystemAdminsTable';

const AdminSettings = function() {
  return (
    <Grid item xs={12}>
      <Grid container spacing={4} alignItems='flex-start'>
        <GrantSystemAdminCard />
        <SystemAdminsTable />
      </Grid>
    </Grid>
  );
};

export default AdminSettings;
